/** Shared walk pose + constants, shared between Canvas/Pixi renderers. */

export const CANVAS_W = 1600;
export const CANVAS_H = 900;

export interface EmpData {
  id: string; name: string; role: string; status: string;
  positionX: number; positionY: number;
}
export interface PoseData {
  x: number; y: number; facing: number; moving: boolean;
}

function easeInOutSine(k: number) { return -(Math.cos(Math.PI * Math.max(0, Math.min(1, k))) - 1) / 2; }

export function getWalkingPose(emp: EmpData, time: number): PoseData {
  const seed = emp.id.split('').reduce((sum, ch, idx) => sum + ch.charCodeAt(0) * (idx + 3), 0);
  // Everyone has a slightly different walking loop length and phase so the room
  // does not look like synchronized soldiers marching on the same beat.
  const cycle = 12600 + (seed % 5200);
  const travel = (emp.role === 'PM' || emp.role === 'PMgr' || emp.role === 'CM' ? 96 : 82) + (seed % 19) - 9;
  const phase = seed % cycle;
  const p = ((time + phase) % cycle) / cycle;
  let offset = -travel, facing = 1, moving = true;
  if (p < 0.42) { offset = -travel + easeInOutSine(p / 0.42) * travel * 2; facing = 1; }
  else if (p < 0.52) { offset = travel; facing = 1; moving = false; }
  else if (p < 0.56) { offset = travel; facing = -1; moving = false; }
  else if (p < 0.90) { offset = travel - easeInOutSine((p - 0.56) / 0.34) * travel * 2; facing = -1; }
  else { offset = -travel; facing = -1; moving = false; }
  return { x: emp.positionX + offset, y: emp.positionY, facing, moving };
}
